jQuery(document).ready(function ($) {
    const items = [];

    $('.js-property-grid-item-gallery').each(function () {
        const selector = `.js-property-grid-item-gallery[data-property-id="${$(this).attr('data-property-id')}"]`;

        const swiper = new Swiper(selector, {
            loop: true,

            slidesPerView: 1,

            autoplay: false,

            //grabCursor: true,

            navigation: {
                prevEl: '.property-grid-item__prev',
                nextEl: '.property-grid-item__next'
            },

            pagination: {
                el: '.property-grid-item__pagination',
                bulletClass: 'property-grid-item__bullet',
                bulletActiveClass: 'active'
            },

            slideClass: 'property-grid-item__image'
        });

        $(selector).on('mouseenter', function () {
            swiper.params.autoplay = { delay: 2000, disableOnInteraction: false };
            swiper.autoplay.start();
        }).on('mouseleave', function () {
            swiper.autoplay.stop();
        });

        items.push(swiper);
    });
});